import { forwardRef, createElement } from 'react';
import cn from 'classnames';

const Form = /*#__PURE__*/forwardRef(function Form(props, ref) {
  const {
    horizontal = false,
    ...otherProps
  } = props;
  const className = cn('yt-form', {
    'yt-form--horizontal flex flex-wrap': horizontal
  }, props.className);
  return createElement("form", Object.assign({}, otherProps, {
    className: className,
    "data-taco": "form",
    ref: ref
  }));
});

export { Form };
//# sourceMappingURL=Form.js.map
